import React, {useState} from "react";

import CRD_ACTIVITIES from './crd_activities/crd_activities';



export default function ACTIVITIES_LIST() {

    //  variable declarations ------------------------------------------------------------------------------------------



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------



    // RENDER CONTAINER ================================================================================================

    return (
        <div id='page--activities_list' className='page'>
            <div className='page__header'>
                <div className='text--xl medium'>Activities</div>
            </div>

            <CRD_ACTIVITIES />

        </div>
    );

}